import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled, { css } from 'styled-components';
import { b as getMargin, a as getPadding } from './styled-utils-3f8463ca.js';

function _templateObject3() {
  var data = _taggedTemplateLiteral(["border-left: 3px solid ", ""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["border-right: 3px solid ", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  font-size: ", ";\n  ", ";\n  ", ";\n\n  > :last-child {\n    margin: 0;\n  }\n\n  cite {\n    display: block;\n    text-align: right;\n    font-size: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledQuote = styled.blockquote(_templateObject(), function (_ref) {
  var rightBorder = _ref.rightBorder;
  return rightBorder ? css(_templateObject2(), function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.primary[3];
  }) : css(_templateObject3(), function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.primary[3];
  });
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.md;
}, function (_ref5) {
  var theme = _ref5.theme;
  return getMargin('mx-3', theme);
}, function (_ref6) {
  var theme = _ref6.theme;
  return getPadding('p-3', theme);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.sm;
});

var Blockquote = function Blockquote(_ref) {
  var children = _ref.children,
      cite = _ref.cite,
      rightBorder = _ref.rightBorder,
      className = _ref.className;
  return React.createElement(StyledQuote, {
    rightBorder: rightBorder,
    className: className
  }, children, cite && React.createElement("cite", null, "\u2014 ", cite));
};

Blockquote.defaultProps = {
  cite: null,
  className: null,
  rightBorder: false
};
Blockquote.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Blockquote",
  "props": {
    "cite": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The author or work to be cited in the blockquote"
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "rightBorder": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether or not to render the border on the right"
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": true,
      "description": "Content of the blockquote"
    }
  }
};
export default Blockquote;
export { Blockquote };